import { Component, ViewEncapsulation, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { ClickData } from 'app/components/table/table.component';
import { PFObject } from 'app/components/data/core/models/base/object';
import { LoadingPoint } from 'app/components/data/core/models/points/points';
import { Supplier } from 'app/components/data/core/models/persons/supplier';

import { EntranceDialog } from '../../../entrance/entrance-dialog.component';
import { EntranceTableData } from '../../../entrance/entrance.tabledata';
import { DialogPresenterService } from 'app/components/dialogs/dialog-presenter/dialog-presenter.service';

import { LocaleService } from 'app/components/locale/locale.service';
import { supplier, points } from '../../../../locale/locale';
import { ActionBarOperation } from 'app/components/action-bar/action-bar.component';
import { TableOperationsHelper } from 'app/components/helpers/table-operations.helper';
let locales = [
  supplier,
  points
];

@Component({
  selector: 'supplier-agreement-dialog',
  templateUrl: './supplier-points-dialog.component.html',
  styleUrls: ['./supplier-points-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class SupplierPointsDialog {
  compareFunction = PFObject.compareFn;
  
  public form: UntypedFormGroup;
  public object: Supplier;

  tableData: EntranceTableData;
  tableOperations: ActionBarOperation[] = [];
  
  constructor(
    private localeService: LocaleService,
    public dialogRef: MatDialogRef<SupplierPointsDialog>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _formBuilder: UntypedFormBuilder,
    private dialogPresenterService: DialogPresenterService
  ) {
    this.localeService.loadLocales(locales);
    this.object = this._data.object;
    this.form = this.createContactForm();

    this.tableOperations = this.makeTableOperations([]);
    let point = this.form.controls.loadingPoint.value;
    this.updateTableData(point);
  }

  getPoints(): LoadingPoint[] {
    let points =  this.object.getLoadingPoints();
    return points;
  }

  pointChanged(point: LoadingPoint) {
    this.updateTableData(point);
  }

  updateOperations(value: ClickData) {
    let selected = value.table.selectedValues();
    this.tableOperations = this.makeTableOperations(selected);
  }

  private makeTableOperations(selected): ActionBarOperation[] {
    return [
      TableOperationsHelper.makeCreateOperation(()=> this.addAddress()),
      TableOperationsHelper.makeEditOperation(() => this.editAddress(selected), selected),
      TableOperationsHelper.makeRemoveOperation(() => this.removeAddress(selected), selected),
    ];
  }

  private addAddress() {
    this.showEntranceDialog('create', null);
  }

  private editAddress(selected) {
    this.showEntranceDialog('edit', selected[0]);
  }

  private removeAddress(selected) {
    this.showRemoveDialog(selected);
  }

  private getPoint(): LoadingPoint {
    return this.form.controls.loadingPoint.value;
  }

  private showEntranceDialog(actionName, item) {
    let point = this.getPoint();
    let data = new Map<string, any>();
    data['action'] = actionName;
    data['object'] = item;
    data['address'] = point.getAddress();

    let handler = this;
    this.dialogPresenterService.showDialog({
      dialog: EntranceDialog,
      panel: 'entrance-dialog-container',
      data: data,
    }, function (entrance) {
      if (entrance) {
        if (actionName === 'create') {
          point.addEntrance(entrance);
        }
        point.save().then(success => {
          if (success) {
            handler.updateTableData(point);
          }
        });
      }
    });
  }

  private showRemoveDialog(selected) {
    let point = this.getPoint();
    this.dialogPresenterService.askRemoveItems(selected, (error) =>  {
      if (!error) {
        selected.forEach((entrance) => {
          point.removeEntrance(entrance);
        });
        point.save().then(success => {
          if (success) {
            this.updateTableData(point);
          }
        })
      }
    })
  }

  private updateTableData(point) {
    this.tableData = new EntranceTableData(point)
  }

  private createContactForm(): UntypedFormGroup {
    let points = this.getPoints();
    let firstPoint = points && points.length > 0 ? points[0] : null;

    return this._formBuilder.group({
      loadingPoint: firstPoint,
    });
  }
}
